import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode } from 'swiper/modules';
import 'swiper/css';
import './FeatureMarquee.css';

const features = [
  'Get paid up to 2 days early',
  'No monthly fees',
  'Fee-free overdraft',
  '60k+ fee‑free ATMs',
  'FDIC insured',
  'High‑yield savings',
  'Mobile check deposit',
  'Card lock & security',
  '24/7 support',
];

const FeatureMarquee = () => {
  return (
    <section className="feature-marquee">
      <div className="gn-container">
        <Swiper
          modules={[Autoplay, FreeMode]}
          spaceBetween={12}
          slidesPerView={'auto'}
          freeMode={{ enabled: true, momentum: false }}
          loop
          speed={6000}
          autoplay={{ delay: 0, disableOnInteraction: false, pauseOnMouseEnter: false }}
          allowTouchMove={false}
        >
          {features.map((text, idx) => (
            <SwiperSlide key={idx} className="feature-slide">
              <div className="feature-pill">{text}</div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default FeatureMarquee;


